export default "__VITE_ASSET__dce2c8dd__"